import React, { Component } from "react";
import styles from "./ExtraSLideItem.local.scss";
import classnames from "classnames";

export default class ExtraSlideListFetching extends Component {
  render() {
    let items = [];
    for (let i = 0; i < 3; i++) {
      items.push(
        <div className={"row medium-12"}>
          <div className={classnames("medium-4", styles.slide_item)}>
            <ul>
              <li
                className={
                  this.props.extraSlidesInModal
                    ? classnames(styles.slide_card, styles.in_modal)
                    : styles.slide_card
                }
              >
                <div className={styles.slide_container}>
                  <div className={`${styles.item} ${styles.gradiant}`}>
                    {""}
                  </div>
                </div>
                <div className={styles.informations_container}>
                  <div className={`${styles.title}`}>
                    <h3 className={styles.gradiant}>{""}</h3>
                  </div>
                  <div
                    className={styles.list__row_groups_cell_wrapper}
                    style={{ marginBottom: "5px" }}
                  >
                    <h4 className={styles.gradiant}>{""}</h4>
                  </div>
                  <div className={styles.more_information}>
                    <div className={styles.actions_container}>
                      <div className={styles.actions} />
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div className={classnames("medium-4", styles.slide_item)}>
            <ul>
              <li
                className={
                  this.props.extraSlidesInModal
                    ? classnames(styles.slide_card, styles.in_modal)
                    : styles.slide_card
                }
              >
                <div className={styles.slide_container}>
                  <div className={`${styles.item} ${styles.gradiant}`}>
                    {""}
                  </div>
                </div>
                <div className={styles.informations_container}>
                  <div className={`${styles.title}`}>
                    <h3 className={styles.gradiant}>{""}</h3>
                  </div>
                  <div
                    className={styles.list__row_groups_cell_wrapper}
                    style={{ marginBottom: "5px" }}
                  >
                    <h4 className={styles.gradiant}>{""}</h4>
                  </div>
                  <div className={styles.more_information}>
                    <div className={styles.actions_container}>
                      <div className={styles.actions} />
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div className={classnames("medium-4", styles.slide_item)}>
            <ul>
              <li
                className={
                  this.props.extraSlidesInModal
                    ? classnames(styles.slide_card, styles.in_modal)
                    : styles.slide_card
                }
              >
                <div className={styles.slide_container}>
                  <div className={`${styles.item} ${styles.gradiant}`}>
                    {""}
                  </div>
                </div>
                <div className={styles.informations_container}>
                  <div className={`${styles.title}`}>
                    <h3 className={styles.gradiant}>{""}</h3>
                  </div>
                  <div
                    className={styles.list__row_groups_cell_wrapper}
                    style={{ marginBottom: "5px" }}
                  >
                    <h4 className={styles.gradiant}>{""}</h4>
                  </div>
                  <div className={styles.more_information}>
                    <div className={styles.actions_container}>
                      <div className={styles.actions} />
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      );
    }
    return (
      <div className={`small-12 columns ${styles.item__fetching}`}>{items}</div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ExtraSlides/ExtraSlideListFetching.js